export function trackSignup(signupType) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
     'event': 'sign_up',
     'source_form': signupType
    });
   }

   export function trackLogin() {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
     'event': 'login',
    });
   }

   export function apiTrackQuoteRequest(apiDocuments, templates, users) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
     'event': 'api_quote_request',
     'api_documents': apiDocuments,
     'templates': templates,
     'users': users,
    });
   }


   export function pricingTrackQuoteRequest(apiDocuments, templates, users) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
     'event': 'pricing_quote_request',
     'users': users,
     'templates': templates,
     'api_documents': apiDocuments,
    });
   }


function getItemId(itemCategory, itemName, itemVariant) {
    switch (itemCategory) {
        case 'API':
            switch (itemName) {
                case 'API Light':
                    return itemVariant === 'monthly' ? 'API-LIG-M' : 'API-LIG-Y';
                default:
                    return null;
            }
        case 'standard':
        case '':
            switch (itemName) {
                case 'Basic':
                    return itemVariant === 'monthly' ? 'STA-BAS-M' : 'STA-BAS-Y';
                case 'Professional':
                    return itemVariant === 'monthly' ? 'STA-PRO-M' : 'STA-PRO-Y';
                case 'Professional Plus':
                    return itemVariant === 'monthly' ? 'STA-PLU-M' : 'STA-PLU-Y';
                default:
                    return null;
            }
        default:
            return null;
    }
}



export function trackPurchase(id, amount, currency, itemCategory, itemName, itemVariant) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
     'event': 'purchase',
     'ecommerce': {
        "transaction_id": id,
        'value': amount,
        'currency': currency,
        'items': [
           {
            item_id: getItemId(itemCategory, itemName, itemVariant),
            item_category: itemCategory,
            item_name: itemName,
            item_variant: itemVariant
          }]
     }
})}


export function trackXodoTools30PromoPopupDisplay() {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'xodo_tools_30promo_popup_display',
    });
}

export function trackXodoTools30PromoPopupCloseClick() {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'xodo_tools_30promo_popup_close_click',
    });
}

export function trackXodoTools30PromoPopupUpgradeCTAClick() {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'xodo_tools_30promo_popup_upgrade_cta_click',
    });
}

export function trackXodoTools30PromoPopupSalesCTAClick() {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'xodo_tools_30promo_popup_sales_cta_click',
    });
}

export function trackXodoTools30TryNowCTAClick() {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'xodo_tools_30promo_popup_try_now_cta_click',
    });
}
